import React, { useEffect, useState } from 'react'
import { Field, Formik, Form } from 'formik'
import * as Yup from 'yup'
import { FileUpload, TextInput } from '../../../components'
import { Link, useNavigate } from 'react-router-dom'
import LoggedInUserService from '../../../services/AuthService'
import useAxios from '../../../hooks/useAxios'
import Constants from '../../../Constants'
const userLogo = require("../../../assets/images/user.png")

const SuperProfile = () => {
  const { postData, putData } = useAxios()

  let navigate = useNavigate();
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
  })
  const [profilefileName, setprofilefileName] = useState({
    fileName: "",
    imageUrl: null
  });
  useEffect(() => {
    const data = LoggedInUserService.GetLoggedInUserData();
    const imageUrl = data?.profileImageUrl;
    setUser(data)
    setprofilefileName({ imageUrl: imageUrl });
  }, [])


  const validationSchema = Yup.object().shape({
    email: Yup.string().required('Email is required').email('Please enter a valid email'),
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
  });

  const onProfileUpload = (files, setFieldValue) => {
    const newFiles = Array.isArray(files.file) ? files.file : [files.file];
    const selectedFile = newFiles[0];
    if (!selectedFile) return;
    setprofilefileName(selectedFile.name);
    setprofilefileName((prev) => ({
      ...prev,
      fileName: selectedFile.name,
      imageUrl: URL.createObjectURL(selectedFile)
    }));
    setFieldValue('companyLogo', selectedFile);
  };

  const onSubmit = (values, setErrors) => {
    const data = LoggedInUserService.GetLoggedInUserData();
    const domain = data.domainName;
    let formData = new FormData();
    formData.append('firstName', values?.firstName)
    formData.append('lastName', values?.lastName)
    formData.append('email', values?.email)
    formData.append('domainName', domain)

    putData(Constants.ApiUrl.user.updateProfile, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((res) => {
      LoggedInUserService.UpdateLoggedInUserSession(res?.token);
    }).catch(err => {

    })

  }
  const resetPassword = () => {
    const data = LoggedInUserService.GetLoggedInUserData();
    const domain = data.domainName;
    const values = {
      email: user?.email,
      profile: true,
      domainName: domain,
    };
    postData(Constants.ApiUrl.auth.forgotPassword, values).then((res) => {
      console.log(res, "res");
      if (res) {
        navigate('/forgot-password', { state: { fromReset: true, data: res } });
      }
    }).catch(err => {
    })
  }

  return (
    <section className='content-wrapper'>
      <div class="container layout-container case-form">
        <div className="listing">
          <Formik
            initialValues={{ ...user }}
            validationSchema={validationSchema}
            enableReinitialize={true}
            onSubmit={(values, { setErrors }) => {
              onSubmit(values)
            }}
          >
            {({ errors, touched, isSubmitting, setFieldValue }) => {
              return (
                <Form>
                  <div className="add-form p-0">
                    <div class="row align-items-center mb-10">
                      <div class="col-md-6">
                        <span style={{ fontSize: '40px', color: 'black', fontFamily: 'Baskerville', fontWeight: 'bold' }}>Personal Information</span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <Field name="firstName" type="text" removeMargin={true} label="First Name" placeholder="Enter here" component={TextInput} />
                        </div>
                        <div className="form-group">
                          <Field name="lastName" type="text" removeMargin={true} label="Last Name" placeholder="Enter here" component={TextInput} />
                        </div>
                        <div className="form-group">
                          <Field disabled name="email" type="email" removeMargin={true} label="Email Address" placeholder="Enter here" component={TextInput} />
                        </div>
                        <Link className="frgt"
                          onClick={() => resetPassword()}
                        >Reset Password?</Link>
                      </div>
                    </div>
                    <div className="btns text-end">
                      <a onClick={() => navigate('/super/companies')} className="btn btn-theme btn-outline me-3">Cancel</a>
                      <button type='submit' className="btn btn-theme">Save Changes</button>
                    </div>
                  </ div>
                </Form>
              )
            }}
          </Formik>
        </div>
      </div>
    </section>

  )
}

export default SuperProfile;